import React from 'react';
import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle, Slide,
} from '@material-ui/core';
import {
  isEmpty, map, max, sumBy,
} from 'lodash';
import withCammaDollarString from '../../../hocs/withCammaDollarString';

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

export default function DiscountModal({
  couponDiscount,
  hideOkButton,
  isOpened,
  itemAmount,
  onCancelButtonClick,
  onOkButtonClick,
  originalPrice,
  productDiscountAmount,
  shopCampaignDiscounts,
}) {
  const {
    title: couponVoucherName,
    discount: discountAmount = 0,
  } = couponDiscount || {};

  const productCampaignDiscount = (shopCampaignDiscounts || []).reduce((result, discount) => {
    const {
      amount,
      type,
    } = discount;
    if (type === 'PRODUCT_CAMPAIGN') return (amount || 0) + result;
    return result;
  }, 0);

  return (
    <Dialog
      open={isOpened}
      onClose={onCancelButtonClick}
      maxWidth="xs"
      fullWidth
      TransitionComponent={Transition}
    >
      <DialogTitle>
        優惠試算
      </DialogTitle>
      <DialogContent className="fz-text-center">
        <div className="fz-flex fz-justify-between">
          <span>原價總計</span>
          <span>{`$${withCammaDollarString(originalPrice)}`}</span>
        </div>
        {
          productCampaignDiscount ? (
            <div className="fz-flex fz-justify-between">
              <span>商品優惠</span>
              <span>{`-$${withCammaDollarString(productCampaignDiscount)}`}</span>
            </div>
          ) : null
        }
        {productDiscountAmount > 0 ? (
          <div className="fz-flex fz-justify-between">
            <span>商品優惠</span>
            <span>{`-$${withCammaDollarString(productDiscountAmount)}`}</span>
          </div>
        ) : null}
        <hr />
        <div className="fz-flex fz-justify-between">
          <span>小計</span>
          <span>{`$${withCammaDollarString(originalPrice - productDiscountAmount - productCampaignDiscount)}`}</span>
        </div>
        {!isEmpty(shopCampaignDiscounts) && (
          <>
            {map(shopCampaignDiscounts, (discount) => (
              discount.type === 'SHOP_CAMPAIGN' ? (
                <div className="fz-flex fz-justify-between fz-text-xs" key={discount.name}>
                  <span>{discount.name}</span>
                  <span
                    className={`
                      ${discount.message && 'fz-text-onSale'}
                      `}
                  >
                    {`${discount.message || `-$${withCammaDollarString(discount.amount)}`}`}
                  </span>
                </div>
              ) : null
            ))}
          </>
        )}
        {couponDiscount && (
          <>
            <div className="fz-flex fz-justify-between">
              <span>優惠券優惠</span>
            </div>
            <div className="fz-flex fz-justify-between fz-text-xs">
              <span>{couponVoucherName}</span>
              <span>{`-$${withCammaDollarString(discountAmount)}`}</span>
            </div>
          </>
        )}
        <div className="fz-flex fz-justify-between">
          <span>合計</span>
          <span className="fz-text-onSale">
            {`$${withCammaDollarString(max([originalPrice - (sumBy(shopCampaignDiscounts, 'amount') || 0) - productDiscountAmount - discountAmount, 0]))}`}
          </span>
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          onClick={onCancelButtonClick}
          fullWidth
        >
          關閉
        </Button>
        {hideOkButton ? null : (
          <Button
            className="!fz-text-white"
            color="secondary"
            fullWidth
            onClick={onOkButtonClick}
            variant="contained"
          >
            {`結帳 (${itemAmount})`}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
